import { ReactNode } from 'react'
import { ShieldAlert } from 'lucide-react'
import { PermissionsProvider, usePermission } from '@/providers/permissions'
import { EmptyState } from '@/components/common/EmptyState'
import { PageLoader } from '@/components/common/Loaders'

type Requirement = {
  resource: string
  action?: string
}

export function AccessDenied({
  title = 'Acesso restrito',
  description = 'Seu perfil não tem permissão para acessar esta área. Fale com o responsável pela imobiliária.'
}: {
  title?: string
  description?: string
}) {
  return <EmptyState icon={ShieldAlert} title={title} description={description} className="py-24" />
}

interface PermissionGateProps {
  requires?: Requirement | Requirement[]
  children: ReactNode
  fallback?: ReactNode
  loadingFallback?: ReactNode
  companyId?: string
}

function PermissionCheck({ requires, children, fallback, loadingFallback }: Omit<PermissionGateProps, 'companyId'>) {
  const { hasPermission, loading } = usePermission()
  const list = Array.isArray(requires) ? requires : requires ? [requires] : []
  const allowed = list.length === 0 || list.every(item => hasPermission(item.resource, item.action))
  if (loading) return <>{loadingFallback ?? <PageLoader />}</>
  if (!allowed) return <>{fallback || <AccessDenied />}</>
  return <>{children}</>
}

export function PermissionGate({ companyId, ...props }: PermissionGateProps) {
  if (companyId) {
    return (
      <PermissionsProvider scopeCompanyId={companyId}>
        <PermissionCheck {...props} />
      </PermissionsProvider>
    )
  }
  return <PermissionCheck {...props} />
}
